export const parseMonitorMessage = (data) => {
    if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        return null;
    }
    const payload = data;
    if (payload.type === 'mousemove') {
        if (typeof payload.clientX !== 'number' ||
            !Number.isFinite(payload.clientX) ||
            typeof payload.clientY !== 'number' ||
            !Number.isFinite(payload.clientY)) {
            return null;
        }
        return {
            type: 'mousemove',
            clientX: payload.clientX,
            clientY: payload.clientY,
        };
    }
    if (payload.type === 'mousedown' || payload.type === 'mouseup') {
        return { type: payload.type };
    }
    if (payload.type === 'keydown' || payload.type === 'keyup') {
        if (typeof payload.key !== 'string' ||
            payload.key.length < 1 ||
            payload.key.length > 64) {
            return null;
        }
        return { type: payload.type, key: payload.key };
    }
    return null;
};
